import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Achivement.css";
import achTopIcon from "../../image/newImg/ach.png";
import bullet_icon from "../../image/bullet_icon.svg";
import award_1 from "../../image/award_1.jpg";
import award_2 from "../../image/award_2.jpg";
import award_3 from "../../image/award_3.jpg";
import award_4 from "../../image/award_4.jpg";
import award_5 from "../../image/award_5.jpg";
import award_6 from "../../image/award_6.jpg";
import award_7 from "../../image/award_7.jpg";
import award_8 from "../../image/award_8.jpg";
import award_9 from "../../image/award_9.jpg";
import award_10 from "../../image/award_10.jpg";
import a1 from "../../image/newImg/a1.jpg";
import a2 from "../../image/newImg/a2.jpg";
import a3 from "../../image/newImg/a3.jpg";
import a4 from "../../image/newImg/a4.jpg";
import a5 from "../../image/newImg/a5.jpg";
import a6 from "../../image/newImg/a6.jpg";
import a7 from "../../image/newImg/a7.jpg";
import a8 from "../../image/newImg/a8.jpg";
import a9 from "../../image/newImg/a9.jpg";
import a10 from "../../image/newImg/a10.png";
import a11 from "../../image/newImg/a11.png";
import a12 from "../../image/newImg/a12.jpg";
import { Col, Row } from "react-bootstrap";
import Slider from "react-slick";

function Achievements(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const images = [
    award_1,
    award_2,
    award_3,
    award_4,
    award_5,
    award_6,
  ];

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`}>
            Achievements & Laurels
          </div>
          <div className="col-lg-10">
            <div className="d-flex gap-2 mt-1">
              <div className="container">
                <div className="color-grey f-500">
                  The harder you work for something, the greater you'll feel
                  when you achieve it." It is a jubilant & escatic moment for
                  HGS to announce that our school has been
                  nominated for the Global Awards for its astounding innovation
                  in Pedagogy.
                </div>
                <div className="color-grey f-500">
                  The awards and achievements of our school and students are
                  always a source of pride and also a reminder for all of us to
                  work together and bring the glory back to us every time. They
                  are also an inspiration for our coming generations to look up
                  to and give their best in every field they work hard for. Some
                  of our glorious achievements are stated below.
                </div>



                <div className="achievement_section mt-5">
                  <div className="achievement_content">
                    <div className="col-lg-12 achiecontent">
                      <h2 className="section_titless">School’s Achievements</h2>
                      <ul>
                        <li>
                          HGS was awarded as Best school for
                          cleanliness in Bhopal among 200 schools by “Adani Group”
                          for cleanliness in the year 2019.
                        </li>
                        <li>
                          Received award for cleanliness, recognized by Municipal
                          Corporation among all schools in Bhopal and awarded
                          Principal, Teachers and Students in the year 2020.
                        </li>
                        <li>
                          {" "}                          4 teachers were awarded the
                          school excellence award in the year 2021 by the “Hope and
                          Care Foundation “.
                        </li>
                        <li>
                          {" "}
                          School Head was awarded the Best Educationist and Mentor
                          Award by “Constitution club of India, New Delhi” for the
                          year 2021.
                        </li>
                        <li>
                          HG  School was awarded the
                          Excellence Certificate by “Bharat Shiksha Puraskar” for
                          its Outstanding Contribution to Indian Education for the
                          year 2021.
                        </li>
                        <li>                          5 teachers were awarded the
                          School Excellence Award.
                        </li>
                        <li>
                          Received award for cleanliness, recognized by Municipal
                          Corporation, Bhopal and awarded Principal, Teachers and
                          Students.
                        </li>
                        <li>
                          11 Prizes in Inter HGS sport events and 8 prizes in Inter
                          HGS literary events. 3 Science models were awarded in
                          Inter HGS Science competitions.
                        </li>
                        <li>
                          HGS Bhopal was upgraded to Senior
                          Secondary School in the year 2021, affiliated to MPBSE.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="container py-4 silderac">
                  <h2 className="fw-bold text-center mb-4">Awards Gallery</h2>

                  <Slider {...settings}>
                    {images.map((img, i) => (
                      <div key={i} className="img-slide-wrapper">
                        <img src={img} alt="gallery" className="slider-img" />
                      </div>
                    ))}
                  </Slider>
                </div>

               
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Achievements;
